import {
  NgModule,
  ApplicationRef
} from '@angular/core';

import { MatButtonModule, MatCheckboxModule, MatGridListModule,
  MatMenuModule, MatToolbarModule, MatSidenavModule, MatIconModule, MatCardModule,
  MatInputModule, MatDialogModule, MatSlideToggleModule,
  MatTableModule, MatPaginatorModule, MatSortModule, MatTabsModule, MatListModule,
  MatSelectModule, MatAutocompleteModule, MatProgressBarModule, MatProgressSpinnerModule,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDatepickerModule, MatExpansionModule, MatRadioModule,
  MatRippleModule, MatTooltipModule, MatChipsModule} from '@angular/material';

const impExp = [
  MatButtonModule,
  MatCheckboxModule,
  MatGridListModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatIconModule,
  MatCardModule,
  MatInputModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatTabsModule,
  MatListModule,
  MatSelectModule,
  MatAutocompleteModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatDatepickerModule,
  MatExpansionModule,
  MatRadioModule,
  MatRippleModule,
  MatTooltipModule,
  MatChipsModule
];

@NgModule({
  imports: impExp,
  exports: impExp,
})
export class MaterialModule {}



// WEBPACK FOOTER //
// ./src/app/material.module.ts